export const SET_LAWS_MY_ACTIONS_FETCHING = 'SET_LAWS_MY_ACTIONS_FETCHING';
export const SET_LAWS_MY_ACTIONS = 'SET_LAWS_MY_ACTIONS';
export const SET_LAWS_MY_ACTIONS_ERROR = 'SET_LAWS_MY_ACTIONS_ERROR';
export const CLEAN_LAWS_MY_ACTIONS = 'CLEAN_LAWS_MY_ACTIONS';
export const ABORT_LAWS_MY_ACTIONS_REQUEST = 'ABORT_LAWS_MY_ACTIONS_REQUEST';
export const RESET_LAWS_MY_ACTIONS_FETCHING = 'RESET_LAWS_MY_ACTIONS_FETCHING';



// WEBPACK FOOTER //
// ./src/redux_related/lawsMyActions/actions.js